import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/layout';
import db from '@klinx/utils/localstorage';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import dayjs from 'dayjs';
// import versionTood from '@klinx/utils/versionUpdate.js';
import smartBiRouter from '@klinx/smart-bi/src/router';
import baseRouter from '@klinx/base/src/router';
import terminalRoutes from '@klinx/base/src/router/terminal';
import wmsRouter from '@klinx/wms/src/router';
import emsRouter from '@klinx/ems/src/router';
import mesRouter from '@klinx/mes/src/router';
import ccsRouter from '@klinx/ccs/src/router';
import qmsRouter from '@klinx/qms/src/router';
import apsRouter from '@klinx/aps/src/router';
import tpmRouter from '@klinx/tpm/src/router';
import agvRouter from '@klinx/agv/src/router';
import expertRouter from '@klinx/expert/src/router';
import casRouter from '@klinx/cas/src/router';

Vue.use(Router);

/**
 *  https://panjiachen.github.io/vue-element-admin-site/zh/guide/essentials/router-and-nav.html
 *
 *  hidden: true                 //默认 false,当设置 true 的时候该路由不会在侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
 *  redirect: 'noRedirect'       //当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 *  alwaysShow: true
 *  // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *  // 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
 *  // 若你想不管路由下面的 children 声明的个数都显示你的根路由
 *  // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 *
 *  name: 'router-name'          // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 *  meta: {
 *   roles: ['admin', 'editor'] // 设置该路由进入的权限，支持多个权限叠加
 *   title: 'title'             // 设置该路由在侧边栏和面包屑中展示的名字
 *   icon: 'svg-name'           // 设置该路由的图标，支持 svg-class，也支持 el-icon-x element-ui 的 icon
 *   noCache: true              // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
 *   breadcrumb: false          //  如果设置为false，则不会在breadcrumb面包屑中显示(默认 true)
 *   affix: true                // 如果设置为true，它则会固定在tags-view中(默认 false)
 *   activeMenu: '/article/list'
 *   // 当路由设置了该属性，则会高亮相对应的侧边栏。
 *   // 这在某些场景非常有用，比如：一个文章的列表页路由为：/article/list
 *   // 点击文章进入文章详情页，这时候路由为/article/1，但你想在侧边栏高亮文章列表的路由，就可以进行如下设置
 *  }
 **/
const constRouter = [{
  path: '/redirect/index',
  name: 'RedirectPage',
  component: resolve => require(['@/views/redirect/index'], resolve)
},
{
  path: '/404',
  component: resolve => require(['@/views/error-page/404'], resolve),
  hidden: true
},
{
  path: '/login',
  name: 'Login',
  component: resolve => require(['@/views/login/index'], resolve)
},
{
  path: '/home',
  component: Layout,
  redirect: '/home/index',
  children: [{
    path: 'index',
    component: resolve => require(['@/views/home/index'], resolve),
    name: 'Home',
    meta: {
      title: 'Home',
      onlyNavbar: true
    }
  }]
},
{
  path: '/ban',
  name: 'Ban',
  component: resolve => require(['@/views/ban/index'], resolve)
},
{
  path: '/',
  component: Layout,
  redirect: '/dashboard',
  children: [{
    path: 'dashboard',
    component: resolve => require(['@/views/dashboard/index'], resolve),
    name: 'Dashboard',
    meta: {
      title: 'Dashboard',
      icon: 'ofdatabase',
      affix: true
    }
  }]
},
{ // iframe显示外部页面
  path: '/frame',
  component: Layout,
  redirect: '/frame/index',
  children: [{
    path: 'index',
    component: resolve => require(['@/views/frame-page/index'], resolve),
    name: 'FramePage',
    meta: {
      title: 'FramePage',
      icon: 'ofdatabase',
      noCache: true
    }
  }]
},
{
  path: '/profile',
  component: Layout,
  redirect: '/profile/index',
  hidden: true,
  children: [{
    path: 'index',
    component: resolve => require(['@/views/profile/index'], resolve),
    name: 'Profile',
    meta: {
      title: 'profile',
      icon: 'user',
      noCache: true
    }
  }]
},
{
  path: '/terminal',
  component: Layout,
  redirect: '/terminal/equipment/index', // 该路由在base模块
  hidden: true,
  alwaysShow: true,
  /**
   * 1.base保留原来终端目录
   * 2.只导入baseRouter的终端相关路由，直接...baseRouter时，eoms打包会找内部依赖，各种报错
   */
  children: terminalRoutes
},
...baseRouter,
...mesRouter,
...wmsRouter,
...ccsRouter,
...emsRouter,
...smartBiRouter,
...qmsRouter,
...apsRouter,
...tpmRouter,
...agvRouter,
...expertRouter,
...casRouter
];
const router = new Router({
  // 解决vue框架页面跳转有白色不可追踪色块的bug
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  },
  routes: constRouter
});
const defaultHome = `${window.location.protocol}//${window.location.hostname}:30068/`;

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  if (isChunkLoadFailed) {
    // 用路由的replace方法，并没有相当于F5刷新页面，失败的js文件并没有从新请求，会导致一直尝试replace页面导致死循环
    // 而用 location.reload 方法，相当于触发F5刷新页面，虽然用户体验上来说会有刷新加载察觉，但不会导致页面卡死及死循环，从而解决该问题
    location.reload();
    // const targetPath = $router.history.pending.fullPath;
    // $router.replace(targetPath);
  }
});

// smart-bi 大屏路由
const datavList = smartBiRouter.map(route => route.path).slice(1);

const whiteList = [
  '/login',
  '/ccs/schedule/kanban/schedule-kanban',
  '/ccs/schedule/kanban/schedule-kanban-technology',
  '/ccs/schedule/kanban/anhui-kanban',
  '/ccs/schedule/kanban/yl-schedule-kanban',
  '/ccs/schedule/kanban/schedule-kanban-JH',
  '/ccs/schedule/kanban/schedule-kanban-TL',
  '/ccs/schedule/kanban/schedule-kanban-RG',
  '/ban',
  '/redirect/index',
  ...datavList
];

// 异步的路由信息， 同时，左侧菜单也会根据这个来显示
let asyncRouter;

// 导航守卫，渲染动态路由
router.beforeEach((to, from, next) => {
  if (process.env.VUE_APP_TENANT_USER_TOKEN_ENABLE) {
    next();
    return;
  }

  // 判断当前代码版本是否与服务器中代码版本一致，如不一致则刷新页面获取最新
  // versionTood.isNewVersion();
  // 过期时间
  const expireTime = db.get('EXPIRE_TIME');
  // 是否过期
  const isExpire = dayjs().isAfter(dayjs(expireTime));
  console.log('isExpire', isExpire);
  // 是否已登录
  const token = db.get('TOKEN', '');
  // 用户信息
  const user = db.get('USER');
  // 已缓存路由
  const userRouter = db.get('USER_ROUTER', '');
  // 当前路由
  const toPath = to.path;
  // 带url参数的路由，暂时只需匹配一级菜单，不需判断url参数
  // const toPath = `${to.path}?${JSON.stringify(to.query).replace(/:/g, "=").replace(/"/g, '').replace(/,/g, '&').match(/\{([^)]*)\}/)[1]}`;

  if (token && token.length && user) {
    // 未登录，异步路由不存在
    if (!asyncRouter) {
      if (userRouter) {
        asyncRouter = userRouter;
        asyncRouter = filterAsyncRouter(asyncRouter);
        asyncRouter && router.addRoutes(asyncRouter);
        next();
        return;
      }
    }
    if (isExpire) {
      handleLoginExpire(toPath, next);
    } else if (!userRouter && to.path === '/dashboard') { // 没有菜单的情况下，打开应用首页都回到门户
      next('/home/index');
    } else {
      next();
      NProgress.done();
      if (to.path === '/login') {
        db.clear();
        location.reload();
      }
    }
    return;
  }

  // 免登录
  if (whiteList.indexOf(to.path) !== -1) {
    next();
  } else if (db.get('platform') === 'paas' || window.sessionStorage.getItem('platform') === 'paas') {
    window.sessionStorage.removeItem('platform');
    window.location.href = process.env.VUE_APP_PAAS_HOME_URL || defaultHome;
  } else {
    next(`/login?redirectUrl=${encodeURIComponent(toPath)}`);
    NProgress.done();
  }
});

router.afterEach((to) => {
  const { lang: urlLang } = to.query || {};
  const localLang = db.get('LOCAL_LANGUAGE', '');
  const curLang = db.get('LANGUAGE', 'zh', null, true);
  // 路由切换时，如果有需要恢复的语言则重置恢复
  if (!urlLang && localLang && localLang !== curLang) {
    db.save('LANGUAGE', localLang);
    setTimeout(() => window.location.reload(), 300);
    return;
  }

  NProgress.done();
});

function handleLoginExpire(toPath, next) {
  if (db.get('platform') === 'paas') {
    db.clear();
    window.location.href = process.env.VUE_APP_PAAS_HOME_URL || defaultHome;
  } else {
    // 如果已过期，则重定向到登录页
    toPath !== '/login' ? next(`/login?redirectUrl=${encodeURIComponent(toPath)}`) : next();
    db.clear();
    location.reload();
  }
}

function filterAsyncRouter(routes, parent) {
  return routes && routes.filter((route) => {
    const component = route.component;
    if (component) {
      if (route.component === 'Layout') {
        if (route.children && route.children.length > 0 && parent) {
          route.component = (resolve) => {
            require(['@/components/RouterWrap/RouterWrap.vue'], resolve);
          };
        } else {
          route.component = Layout;
        }
      } else if (typeof component === 'string') {
        route.component = view(component);
      }
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, route);
      }
      return true;
    }
  });
}

/**
 * 如果有模块抽离npm不在主工程了，而运行访问的时候这里报错的话
 * 看一下云平台菜单配置路由是否与上面的router列表对应菜单的路由一致，因为如果不一致会经这里在本地找，找不到而报错
 */
function view(path) {
  return function(resolve) {
    require([`@/views/${path}.vue`], resolve);
  };
}

// todo: 登录完回门户首页，暂时不回跳原菜单页面
/**
 * 过滤重定向url
 * @param {Object} navbarRouter 导航路由集
 * @param {String} toPath 拟跳转的路径
 */
// function filterRedirectUrl(navbarRouter, toPath) {
//   let redirectPath = '/home';
//   let childIndex = 0;
//   const toPathPrefix = `${toPath.match(/\/\w+/g)[0]}/`;
//   const parentRoute = navbarRouter.filter(parent => {
//     // 主菜单匹配
//     if (parent.path === toPath || toPath.startsWith(/(\/)$/.test(parent.path) ? parent.path : `${parent.path}/`)) {
//       return true;
//     }

//     // 二级菜单匹配，初步匹配一个序号（路径相同或者包含）
//     return parent.children?.length && parent.children.some((child, index) => {
//       if (child.path === toPath || child.path.startsWith(toPathPrefix)) {
//         childIndex = index;
//         return true;
//       }

//       if (child.children?.length && child.children.some(cchild => cchild.path === toPath || cchild.path
//         .startsWith(toPathPrefix))) {
//         childIndex = index;
//         return true;
//       }
//     });
//   });

//   // 精准匹配二级菜单（路径相同）
//   if (parentRoute.length && parentRoute[0].children) {
//     const matchChildRoute = parentRoute[0].children.filter(child => {
//       if (child.path === toPath) {
//         return true;
//       }

//       return child.children?.length && child.children.some((cchild, cIndex) => {
//         if (cchild.path === toPath) {
//           childIndex = cIndex;
//           return true;
//         }
//       });
//     });
//     // 优先取路径相同的二级菜单，再取路径包含的二级菜单，最后取路径包含的主菜单
//     redirectPath = (matchChildRoute[0]?.children
//       ? matchChildRoute[0].children[childIndex].path
//       : matchChildRoute[0]?.path) ||
//       parentRoute[0].children[childIndex].path;
//   }

//   // 外部连接，改定向到主菜单
//   if (redirectPath.includes('http')) {
//     redirectPath = parentRoute[0].path;
//   }

//   // 如果没有匹配的菜单，则匹配配置的第一个菜单路由
//   // if (!parentRoute.length && navbarRouter[0]?.children) {
//   //   return navbarRouter[0]?.children[0]?.children[0] ? navbarRouter[0]?.children[0]?.children[0]?.path : navbarRouter[0]?.children[0]?.path;
//   // }

//   return redirectPath;
// }

export default router;
